<template>
  <!-- 图片铺满父级色块（与字体图标外框同大）；size 仅约束 Iconify -->
  <span v-if="resolvedUrl" class="module-card-icon-img-wrap">
    <img class="module-card-icon-img" :src="resolvedUrl" alt="" />
  </span>
  <Icon v-else :icon="icon || 'ep:grid'" :size="size" />
</template>

<script lang="ts" setup>
import { isModuleIconImageUrl } from '@/utils/moduleCard'

defineOptions({ name: 'ModuleCardIcon' })

const props = withDefaults(
  defineProps<{
    iconUrl?: string
    icon?: string
    size?: number
  }>(),
  { size: 22 }
)

const resolvedUrl = computed(() => {
  const url = String(props.iconUrl || '').trim()
  return isModuleIconImageUrl(url) ? url : ''
})
</script>

<style scoped>
/* 父级需 position:relative + 固定宽高（.module-icon / .quick-icon / .prod-icon / .buy-module-icon） */
.module-card-icon-img-wrap {
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: inherit;
}

.module-card-icon-img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}
</style>
